import React, { useContext } from "react";
import Snowfall from "react-snowfall";
import { ThemeContext, themes } from "../contexts/ThemeContext";

export default function SnowFallComponent() {
    const { theme } = useContext(ThemeContext);

    const isChristmasSeason = React.useMemo(() => {
        const month = new Date().getMonth();
        return month === 11; // Diciembre
    }, []);

    const snowColor = theme === themes.light ? "#9a9a9a" : "#ffffff";

    return isChristmasSeason && (
        <Snowfall color={snowColor} />
    )
}